const authenticatedRoutes = [
  "/cart",
  "/checkout",
  "/order-history",
  "/thanks/:id",
];

export default authenticatedRoutes;
